import { supabase } from '@/supabase';
import { defineStore } from 'pinia';
import { ref } from 'vue';
export const useUserStore = defineStore(
    'user',
    () => {
        const name = ref('');
        const image = ref(null);
        const firstName = ref('');
        const lastName = ref('');
        const profileImg = ref(null);
        const email = ref('');
        const mobile = ref('');
        const payment_mobile = ref('');
        const country = ref('');
        const state = ref('');
        const city = ref('');
        const countryId = ref(null);
        const stateId = ref(null);
        const cityId = ref(null);
        const role = ref('');
        const id = ref(null);
        const authUid = ref(null);
        const cachedAt = ref(null);
        const authInitialized = ref(false);
        const accessToken = ref(null);

        const setUser = (userData) => {
            name.value = userData.name || '';
            firstName.value = userData.firstName || '';
            lastName.value = userData.lastName || '';
            profileImg.value = userData.profileImg || null;
            email.value = userData.email || '';
            mobile.value = userData.mobile || '';
            payment_mobile.value = userData.payment_mobile || '';
            country.value = userData.country || '';
            state.value = userData.state || '';
            city.value = userData.city || '';
            countryId.value = userData.countryId || null;
            stateId.value = userData.stateId || null;
            cityId.value = userData.cityId || null;
            role.value = userData.role || '';
            id.value = userData.id || null;
            authUid.value = userData.authUid || null;
            cachedAt.value = Date.now();
        };

        const updateUser = (updates) => {
            if (updates.name !== undefined) name.value = updates.name;
            if (updates.firstName !== undefined) firstName.value = updates.firstName;
            if (updates.lastName !== undefined) lastName.value = updates.lastName;
            if (updates.email !== undefined) email.value = updates.email;
            if (updates.mobile !== undefined) mobile.value = updates.mobile;
            if (updates.payment_mobile !== undefined) payment_mobile.value = updates.payment_mobile
            if (updates.country !== undefined) country.value = updates.country;
            if (updates.state !== undefined) state.value = updates.state;
            if (updates.city !== undefined) city.value = updates.city;
            if (updates.countryId !== undefined) countryId.value = updates.countryId;
            if (updates.stateId !== undefined) stateId.value = updates.stateId;
            if (updates.cityId !== undefined) cityId.value = updates.cityId;
            if (updates.profileImg !== undefined) profileImg.value = updates.profileImg;
            if (updates.role !== undefined) role.value = updates.role;
            if (updates.id !== undefined) id.value = updates.id;
            if (updates.authUid !== undefined) authUid.value = updates.authUid;
            cachedAt.value = Date.now();
        };

        const setImage = (imgUrl) => {
            image.value = imgUrl;
        };

        const setAuth = (token) => {
            accessToken.value = token;
            authInitialized.value = true;
        };

        const isCacheValid = (ttlMinutes = 30) => {
            if (!cachedAt.value) return false;
            const ageMinutes = (Date.now() - cachedAt.value) / 60000;
            return ageMinutes <= ttlMinutes;
        };

        const clearUser = () => {
            name.value = '';
            image.value = null;
            firstName.value = '';
            lastName.value = '';
            profileImg.value = null;
            email.value = '';
            mobile.value = '';
            payment_mobile.value = '';
            country.value = '';
            state.value = '';
            city.value = '';
            countryId.value = null;
            stateId.value = null;
            cityId.value = null;
            role.value = '';
            id.value = null;
            authUid.value = null;
            cachedAt.value = null;
            authInitialized.value = false;
            accessToken.value = null;
        };
        const refreshUser = async () => {
            if (!id.value) return null;

            const { data, error } = await supabase
                .from('users')
                .select('*')
                .eq('id', id.value)
                .single();

            if (error) {
                console.error('Refresh User Error:', error);
                return null;
            }

            setUser({
                id: data.id,
                authUid: data.auth_uid,
                name: `${data.first_name || ''} ${data.last_name || ''}`,
                firstName: data.first_name || '',
                lastName: data.last_name || '',
                email: data.email || '',
                mobile: data.mobile || '',
                payment_mobile: data.payment_mobile || '',
                profileImg: data.profile_img,
                role: data.role || '',
                country: data.country || '',
                state: data.state || '',
                city: data.city || '',
                countryId: data.country_id || null,
                stateId: data.state_id || null,
                cityId: data.city_id || null
            });

            // image field ne pan update karo
            image.value = data.profile_img || null;

            return data;
        };
        return {
            name,
            image,
            firstName,
            lastName,
            profileImg,
            email,
            mobile,
            payment_mobile,
            country,
            state,
            city,
            countryId,
            stateId,
            cityId,
            role,
            id,
            authUid,
            cachedAt,
            authInitialized,
            accessToken,
            setUser,
            updateUser,
            setImage,
            setAuth,
            isCacheValid,
            clearUser,
            refreshUser
        };
    },
    {
        persist: true
    }
);
